// @noflow
import PropTypes from 'prop-types';

// check that a number is a valid colour number (between 0 and 255)
export function colorNumber(props, propName, componentName) {
    if (process.env.NODE_ENV !== 'production') {
        const value = props[propName];
        if (typeof value !== 'number') {
            return new Error(`Invalid prop '${propName}' in '${componentName}, expect to be a number!`);
        } else if (value % 1 !== 0 || value < 0 || value > 255) {
            return new Error(
                `Invalid prop ${propName}' in '${componentName}, expect to be an integer between 0 and 255!`
            );
        }
    }
}

// colour colour which should contain a red, green and blue colour
export const colorProptype = PropTypes.shape({
    r: colorNumber,
    g: colorNumber,
    b: colorNumber
});

/**
 * A React prop validation that first checks if another prop meets some expectation
 * before checking itself.
 *
 * @example
 *
 * {
 *     foo: PropTypes.string,
 *     interactive: PropTypes.bool,
 *     onClick: isDependentOn(['interactive'], (onClick, interactive) => interactive, PropTypes.func.isRequired)
 *     onFoo: isDependentOn(['foo'], (onFoo, foo) => foo === 'bar', PropTypes.func.isRequired)
 * }
 *
 * @param  {String[]} 	 dependentOn   names of the props to check first
 * @param  {*|Function}  checkValues   function to call with the props
 * @param  {Function}    propType      own proptype to check if criteria met
 * @return {Function}
 */
export function isDependentOn(dependentOn, checkValues, propType) {
    if (process.env.NODE_ENV !== 'production') {
        return (props, propName, ...args) => {
            const dependents = Array.isArray(dependentOn) ? dependentOn : [dependentOn];
            if (checkValues(props[propName], ...dependents.map(d => props[d]))) {
                return propType(props, propName, ...args);
            }
        };
    }
}



// WEBPACK FOOTER //
// ./src/core/utils/custom-prop-types/index.js